







import { Component, Vue } from 'vue-property-decorator';
import PageTitle from '@/components/common/PageTitle.vue';
import AdminIframe from '@/components/iframe/AdminIframe.vue';

@Component({
  components: {
    PageTitle,
    AdminIframe,
  },
})
export default class AppList extends Vue {
  private remoteSrc = '';

  private setRemoteSrc() {
    const queryObject = { ...this.$route.query, serviceType: 'PREMIUM' };
    const queryString = new URLSearchParams(queryObject).toString();
    this.remoteSrc = process.env.VUE_APP_ADMIN_REMOTE_URL + '/product/management/icon?' + queryString;
  }

  created() {
    this.setRemoteSrc();
  }
}
